module.exports = __webpack_public_path__ + "static/stairs-678367ec4438b8a1bd05146cb9c8cf73.jpg";